import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logoImg from '../assets/images/Layer 1.png';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/AboutLogo_Aiota.css'; // Import the separate CSS file
import { useNavigate } from 'react-router-dom';


const AboutLogo = () => {
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
    const navigate = useNavigate();

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);
  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
      <section className="logo-section">
        <Container>
          <h2 className='logo-title poppins-medium'>ABOUT OUR LOGO</h2>
          <Row>
            {/* Left Side: Paragraph */}
            <Col lg={6} className="mb-4">
              <p className='dark poppins-regular'><strong className='poppins-semibold'>AIOTA logo</strong> is suggestive of community, friendship, love, relationships, care and unity in practice of occupational therapy, which is an integral part of health care system of India.</p>
              <p><strong>The Rays</strong> represent signs of hope, radiant-energy and enthusiasm amongst occupational therapy professionals to promote their important and valuable role in a healthcare team of professionals, for client’s preventive health care, safety and wellbeing; pre-habilitation, rehabilitation and ongoing research to improvise on quality of care.</p>
              <p><strong>Map of India:</strong> Reflects Occupational Therapy profession dedicated to render their expertise in promoting health and wellbeing of the people of India, with varied impairments, dysfunctions and disabilities.</p>
             
            </Col>

            {/* Right Side: Image */}
            <Col lg={6} className="mb-4 text-end d-flex">
              <img src={logoImg} alt="AIOTA Logo" className="logo-image" />
            </Col>
          </Row>

          {/* L Shape Lower Text */}
          <Row>
            <Col>
             <p>Outside of the outer circle of ‘O’ is the name of the national professional organization of occupational therapy in India, which is named <strong>All India - Occupational Therapists’ Association”.</strong> The association is responsible for the growth and advancement of the healthcare profession of Occupational Therapy in India. </p>
              <p><strong>The Color Blue (T + Map of India):</strong> Represents cleanliness, harmony, peace, confidence, truth, and unity. It reflects creativity and loyalty toward clients and trust gained from them.</p>
              <p>
               <strong> Color White (The Transparent or White Color Background)</strong>The represents cleanliness, goodness, humility, innocence, peace, precision, reverence, and youthful zeal in practicing the profession of Occupational Therapy. White is often associated with being fresh and pure. The color white is reflective of, and stimulates creativity, growth and openness in expression of ideas.
              </p>
              <p>
                <strong>Abbreviation AIOTA</strong> next to the Logo is the standard acronym used for the professional body “All India Occupational Therapists’ Association” and it states that it was established in 1952.
              </p>

            </Col>
          </Row>
        </Container>
      </section>
</div>
</div>
    </>
  );
};

export default AboutLogo;